import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { simpleCompare } from "../../../utils/base.util";

import { FieldCoreComponent } from "../FieldCoreComponent";
import { OptionConfigAdapter } from "../OptionConfigAdapter";
import { MedOptionType } from "../types";
import { OptionTypeLocal } from "../types.local";

@Component({
  selector: "med-switch-group",
  templateUrl: "./med-switch-group.component.html",
  styleUrls: ["./med-switch-group.component.scss"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedSwitchGroupComponent),
  }],
})
export class MedSwitchGroupComponent<ValueType> extends FieldCoreComponent<ValueType[]> {
  private _options: OptionTypeLocal<ValueType>[] = [];
  override _value: ValueType[] = [];

  get options(): OptionTypeLocal<ValueType>[] {
    return this._options;
  }

  @Input() set options(list: MedOptionType<ValueType>[]) {
    this._options = list.map(el => new OptionConfigAdapter(el));
  }

  hasValue(value: ValueType): boolean {
    const option = (this.value || []).find(el => JSON.stringify(el) === JSON.stringify(value));
    return Boolean(option);
  }

  onChangeHandler({ target: { checked } }: any, { value }: MedOptionType<ValueType>): void {
    if (checked) {
      this.value.push(value);
      return;
    }

    this.value = this.value.filter(el => !simpleCompare(el, value));
    this.onInput.emit(this.value);
  }
}
